import { RestaurantSegmentEnum } from "@enums";

export const RESTAURANT_SEGMENT_LABELS: Record<RestaurantSegmentEnum, string> = {
    [RestaurantSegmentEnum.ALL]: 'All',
    [RestaurantSegmentEnum.QUICK_SERVICE]: 'Quick Service',
    [RestaurantSegmentEnum.FAST_CASUAL]: 'Fast Casual',
    [RestaurantSegmentEnum.MIDSCALE_DINING]: 'Midscale Dining',
    [RestaurantSegmentEnum.CASUAL_DINING]: 'Casual Dining',
    [RestaurantSegmentEnum.UPSCALE_CASUAL]: 'Upscale Casual',
    [RestaurantSegmentEnum.FINE_DINING]: 'Fine Dining',
};

export const RESTAURANT_SEGMENTS = (
    Object.keys(RESTAURANT_SEGMENT_LABELS) as RestaurantSegmentEnum[]
).map((id) => ({
    id,
    title: RESTAURANT_SEGMENT_LABELS[id]
}));
